import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormLayout1Component } from '@components/form/components/form-layout-1';
import { FormLayout1SuccessComponent } from '@components/form/components/form-layout-1-success';
import { FormLayout2Component } from '@components/form/components/form-layout-2';
import { FormLayout2SuccessComponent } from '@components/form/components/form-layout-2-success';
import { FormLayout3Component } from '@components/form/components/form-layout-3';
import { FormLayout3SuccessComponent } from '@components/form/components/form-layout-3-success';
import { FormLayout4Component } from '@components/form/components/form-layout-4';
import { FormLayout } from '@components/form/config';
import { ComponentLoaderAbstract } from '@services/component-loader';
import { Layout } from '@shared/models';

@Component({
  selector: 'app-form',
  imports: [
    FormLayout1Component,
    FormLayout1SuccessComponent,
    FormLayout2Component,
    FormLayout2SuccessComponent,
    FormLayout3Component,
    FormLayout3SuccessComponent,
    FormLayout4Component,
  ],
  templateUrl: './form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormComponent extends ComponentLoaderAbstract<Layout<FormLayout>> {
  readonly layout = FormLayout;
}
